import React from "react";
import Tooltip from "@mui/material/Tooltip";

// Wraps a role-disabled control in a MUI tooltip that explains why it's disabled.
// Only wraps when `disabled` is true, so enabled controls keep their normal
// layout. The <span> is required for the tooltip to fire on disabled MUI buttons
// (disabled elements don't emit hover events), and carries the not-allowed cursor.
export default function PermissionTooltip({
  disabled,
  reason = "You don't have permission to perform this action",
  children,
}) {
  if (!disabled) return children;
  return (
    <Tooltip title={reason} arrow>
      <span style={{ display: "inline-flex", cursor: "not-allowed" }}>{children}</span>
    </Tooltip>
  );
}
